module.exports = __webpack_public_path__ + "static/SandrineClarac-f032063c21a50220aac27b4499256c3c.jpg";